const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 151c-57.891 0-105 47.109-105 105s47.109 105 105 105 105-47.109 105-105-47.109-105-105-105zm-15 156.211-51.211-51.211 21.211-21.211 30 30 60-60 21.211 21.211z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.544 132.089 24.58-24.58-63.633-63.633-24.58 24.58c-23.935-15.82-50.815-26.953-78.911-32.681v-35.775h-90v35.775c-28.096 5.728-54.976 16.86-78.911 32.681l-24.58-24.58-63.633 63.633 24.58 24.58c-15.82 23.935-26.953 50.815-32.681 78.911h-35.775v90h35.775c5.728 28.096 16.86 54.976 32.681 78.911l-24.58 24.58 63.633 63.633 24.58-24.58c23.936 15.82 50.815 26.953 78.911 32.681v35.775h90v-35.775c28.096-5.728 54.976-16.86 78.911-32.681l24.58 24.58 63.633-63.633-24.58-24.58c15.82-23.936 26.953-50.815 32.681-78.911h35.775v-90h-35.775c-5.728-28.096-16.861-54.976-32.681-78.911zm-187.544 258.911c-74.443 0-135-60.557-135-135s60.557-135 135-135 135 60.557 135 135-60.557 135-135 135z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOp);
export default __webpack_public_path__ + "static/media/op.e3300b922aee7b70aa8786f5262bc355.svg";
export { ForwardRef as ReactComponent };